// icons
import { Icon, IconifyIcon } from '@iconify/react';
// @mui
import { Box, BoxProps, SxProps } from '@mui/material';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  sx?: SxProps;
  icon: IconifyIcon | string;
}

// Default `aria-hidden` so iconography is treated as decorative: when paired with
// visible text (or an explicit aria-label on the parent control), the icon is not
// announced separately. Pass `aria-hidden={false}` to opt in to AT exposure.
export default function Iconify({ icon, sx, ...other }: Props) {
  return (
    <Box
      component={Icon}
      icon={icon}
      aria-hidden
      sx={{ ...sx }}
      {...other}
    />
  );
}
